import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalButtons,
  Button,
  Typography,
} from 'pvs-design-system';

interface UnsavedChangesModalProps {
  open: boolean;
  /** What is being edited, e.g. "folder" or "resource" — used in the message. */
  itemLabel: string;
  /** Keep editing (dismiss the confirmation, return to the form). */
  onKeepEditing: () => void;
  /** Discard changes and close the form. */
  onDiscard: () => void;
}

/**
 * Confirmation modal shown when the user attempts to close an edit form that
 * has unsaved changes. Follows the same design pattern as `DeleteResourceModal`.
 */
const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  itemLabel,
  onKeepEditing,
  onDiscard,
}) => (
  <Modal open={open} onClose={onKeepEditing} ariaLabelledby="unsaved-changes-title">
    <ModalHeader
      id="unsaved-changes-title"
      title="Discard unsaved changes?"
      onClose={onKeepEditing}
    />
    <ModalContent>
      <Typography variant="p-md">
        You have unsaved changes to this {itemLabel}. If you close now, those changes will be lost.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ModalButtons>
        <Button variant="text" color="secondary" size="small" onClick={onKeepEditing}>
          Keep editing
        </Button>
        <Button variant="contained" color="error" size="small" onClick={onDiscard}>
          Discard changes
        </Button>
      </ModalButtons>
    </ModalFooter>
  </Modal>
);

export default UnsavedChangesModal;
